import React, { useCallback, useEffect, useState } from 'react';
import { Form, Input, Row } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ButtonActionPage } from '../../../../../atoms';
import { GRAPHICS } from '../../../../../../constants/define/translation';
import { StyledForm } from '../../../../../organisms/home/form/StyledForm';
import { CreateImagePayload } from '../../../../../../repository/mytm/image/imageRepository';
import { UploadImageAssets } from './UploadImageAssets';

const storageAccountName = process.env.REACT_APP_AZURE_BLOB_ACCOUNT_NAME;
const azureCDN = process.env.REACT_APP_AZURE_CDN;
interface FormAddUpdateImageProps {
  onSaveImage: (values: any) => void;
  record?: CreateImagePayload;
}

export const FormAddUpdateImage = (props: FormAddUpdateImageProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { onSaveImage, record } = props;
  const [form] = Form.useForm();
  const [visibilityTextUploadImage, setVisibilityTextUploadImage] = useState<boolean>(true);
  const onFinish = useCallback(
    values => {
      onSaveImage({
        ...values,
      });
    },
    [record, onSaveImage],
  );

  const onChangeInputUploadImage = useCallback(
    e => {
      setVisibilityTextUploadImage(false);
    },
    [form],
  );

  const onGetUrlUploaded = useCallback(
    (url: string) => {
      const newUrlCDN = azureCDN ? url.replace(`${storageAccountName}.blob.core.windows.net`, azureCDN) : url;
      form.setFieldsValue({
        ...form.getFieldsValue(),
        urlImage: newUrlCDN,
      });
      setVisibilityTextUploadImage(true);
    },
    [form],
  );

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        keyImage: record?.keyImage,
        urlImage: record?.urlImage,
      });
    } else {
      form.resetFields();
    }
  }, [record]);

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onFinish} name="from-add-update-image">
        <Row>
          <StyledForm span={24}>
            <div className="form-scroll">
              <Form.Item
                name="keyImage"
                label={t('form.keyImage')}
                rules={[{ required: true, message: t('validate.keyImageBlank') }]}
              >
                <Input placeholder={t('form.keyImage')} maxLength={255} />
              </Form.Item>
              <Form.Item
                name="urlImage"
                label={t('form.urlImage')}
                rules={[{ required: true, message: t('validate.urlBlank') }]}
                className={`image-backgroundImage ${visibilityTextUploadImage ? '' : 'fileName-bgImage-hidden'}`}
              >
                <Input
                  placeholder={t('form.imagePlaceholder')}
                  suffix={<UploadImageAssets onGetUrlUploaded={onGetUrlUploaded} />}
                  onChange={onChangeInputUploadImage}
                />
              </Form.Item>
            </div>
            <ButtonActionPage
              text={record ? t('btnUpdate') : t('btnCreate')}
              id="1"
              className="btn-submit-form-home"
              htmlType="submit"
              icon={!record ? <FileAddOutlined /> : undefined}
            />
          </StyledForm>
        </Row>
      </Form>
    </>
  );
};
